import {useRouter} from "next/router"
import React, {useContext, useMemo} from "react"
import SelectedFiltersDesktop from "./SelectedFiltersDesktop"
import DataContext from "../../../context/DataContext"
import SelectedFiltersMobile from "./SelectedFiltersMobile"

const SelectedFilters = () => {
	const router = useRouter()
	const {bikeFilters} = useContext(DataContext)
	const {query} = router
	const activeFilters = useMemo(() => Object.entries(query).map(([key, value]) => {
		const values = (value as string).split(",")
		return {
			key,
			activeItems: bikeFilters?.find(item => item.slug === key)?.options?.filter(opt => values.includes(opt.slug))
		}
	}).filter(item => (item.key !== "page" && item.key !== "searchValue")), [query])

	const asPathWithoutQuery = (asPath: string) => {
		if (asPath.includes("zubehoer") || asPath.includes("accessoires")) {
			return asPath.split("&")[0]
		}

		return asPath.split("?")[0]
	}

	const removeFilterByParamKey = async (key:string, slug:string) => {
		const {query, pathname, asPath} = router
		const slugs = (query[key] as string).split(",")
		slugs.splice(slugs.indexOf(slug), 1)
		if (!slugs.length) {
			delete query[key]
		}

		// @ts-ignore
		const queryString = decodeURIComponent(new URLSearchParams(slugs.length ? {
			...query,
			[key]: slugs.join(",")
		} : query).toString())
		await router.push(`${pathname}?${queryString}`, `${asPathWithoutQuery(asPath)}?${queryString}`, {
			shallow: true,
			scroll: false
		})
	}

	const removeAllFilters = async () => {
		const {pathname, asPath, query, locale} = router
		if (query?.categories?.includes("accessories") || query?.categories?.includes("accessoires")) {
			await router.push(pathname + `?categories=${locale === "de" ? "zubehoer" : "accessoires"}`, asPathWithoutQuery(asPath), {
				shallow: true,
				scroll: false
			})
		} else {
			await router.push(pathname, asPathWithoutQuery(asPath), {
				shallow: true,
				scroll: false
			})
		}
	}

	return (
		<>
			<div className="d-md-none">
				<SelectedFiltersMobile showButtonOnly
					activeFilters={activeFilters}
					removeAllFilters={removeAllFilters}
					removeFilterByParamKey={removeFilterByParamKey}/>
			</div>
			<div className="d-none d-md-block">
				<SelectedFiltersDesktop activeFilters={activeFilters}
					removeAllFilters={removeAllFilters}
					removeFilterByParamKey={removeFilterByParamKey}/>
			</div>
		</>
	)
}

export default SelectedFilters
